/* eslint-disable jsx-a11y/anchor-is-valid */
import { useFlags } from 'launchdarkly-react-client-sdk';
import clsx from 'clsx';
import { useEffect } from 'react';
import AppState from '../store/appstate';
import useSiteConfigUnAuth from '../api/sanity/queries/getSiteConfigWithDomain';
import Loading from './loading';
import getColours from '../helpers/getColours';
// import LanguageSelector from '../components/languageSelector';
// import useSiteConfigAuth from '../api/sanity/queries/getSiteConfigWithCode';

function BasicLayout(props) {
  const { children } = props;
  const flags = useFlags();
  const reskinFlag = flags['publishing-dashboard-reskin'];

  const { data:domainConfig, isSuccess: domainConfigIsSuccess } = useSiteConfigUnAuth();
  const { onboardingDarkColour, grad1Colour, grad2Colour } = getColours();
  // const { data: siteConfig } = useSiteConfigAuth();

  const isTunecore = domainConfig?.display_name === 'TuneCore';

  AppState.update((s) => {
    s.hubspotDisabled = domainConfig?.disable_hubspot_tracking;
  });

  const basicLayoutFont = clsx(
    {
    'font-tunecore' : isTunecore,
    'font-sentric' : !isTunecore,
    }
  );
  
  useEffect(() => {
    if (domainConfigIsSuccess) {
      document.title = `${domainConfig?.display_name} Portal`;
    }
  }, [domainConfigIsSuccess]);

  if (!domainConfig || !grad1Colour || !grad2Colour) {
    return <Loading />;
  }

  return (
    <>
    {reskinFlag ? (
      <div className={basicLayoutFont}>
        <div style={{backgroundColor : onboardingDarkColour}} className="p-4">
          {domainConfig?.logo && (
            <img className="h-6 lg:h-12" src={domainConfig.logo} alt="logo" />
          )}
        </div>
        <div
          style={{ backgroundColor: onboardingDarkColour }}
          className="text-white min-h-screen-minus-footer pb-9"
        >
          {/* <div className="flex flex-row-reverse pr-10">
            <LanguageSelector />
          </div> */}
          {children}
        </div>
        <div style={{ backgroundColor: '#24201F' }} className="flex items-center p-2 text-sm text-white">
          <div className="container flex flex-wrap ">
            <div className="w-full lg:w-1/2">
              &copy;
              {' '}
              {domainConfig?.display_name}
              {' '}
              2024
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div className={isTunecore ? 'font-tunecore' : ''}>
        <div
          style={{ background: `radial-gradient(${grad1Colour}, ${grad2Colour})` }}
          className="py-10 text-white min-h-screen-minus-footer"
        >
          {/* <div className="flex flex-row-reverse pr-10">
            <LanguageSelector />
          </div> */}
          {children}
        </div>
        <div style={{ backgroundColor: onboardingDarkColour }} className="flex items-center p-2 text-sm text-white h-14">
          <div className="container flex flex-wrap mx-auto ">
            <div className="w-full lg:w-1/2">
              &copy;
              {' '}
              {domainConfig?.display_name}
              {' '}
              2024
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
}
export default BasicLayout;
